<template>
  <HvhChart
    :visualization="visualization"
    :options="options"
    :yAxisDistributedLabels="yAxisDistributedLabels"
    :height="height || '550px'"
    @dataCreated="$emit('data-created', $event)"
    @wheel="$emit('wheel', $event)"
    @item-clicked="$emit('item-clicked', $event)"
  />
</template>
<script>
import HvhChart from './HvhChart.vue';
export default {
  components: { HvhChart },
  props: ['chartData', 'scales', 'title', 'yAxisDistributedLabels', 'fullBarWidth', 'height', 'barMinHeight'],
  computed: {
    visualization: function () {
      return {
        visualization_type: 'barchart',
        name_field: 'label',
        value_field: 'value',
        data: Array.isArray(this.chartData.datasets[0].data[0]) ? this.chartData.datasets[0].data[0] : this.chartData.datasets[0].data,
        filter_names: {},
        filtered: [],
        patient_counts: []
      }
    },
    options: function () {
      var series = this.chartData.datasets[0].data
        .map(f => ({
          data: f.map(g => ({
            ...g,
            itemStyle: {
              normal: { color: g.color },
              emphasis: { color: g.color, opacity: 1 }
            },
          })),
          type: 'bar',
          stack: 'stack',
          barGap: '-100%',
          barCategoryGap: this.fullBarWidth ? undefined : '80%',
          barMinHeight: this.barMinHeight,
          // color: f[0] ? f[0].color : f.color,
        }));

      return {
        xAxis: this.scales.xAxis || { axisLabel: undefined },
        yAxis: this.scales.yAxis || { axisLabel: undefined },
        tooltip: this.scales.tooltip,
        series: series
      };
    },
  }
}
</script>